// eslint-disable-next-line import/prefer-default-export
export const ERROR_MESSAGE = 'Something went wrong! Please try again!'
